import {
  email,
  required,
  useGetIdentity,
  useRecordContext,
  useTranslate,
} from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { TextInput } from "@/components/admin/text-input";

import type { Sale } from "../types";

/**
 * Shared inputs of the user create and edit forms. Administrators cannot
 * demote or disable their own account, so those two switches are read-only
 * on their own record.
 */
export function SalesInputs() {
  const translate = useTranslate();
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  const isSelf = record != null && String(record.id) === String(identity?.id);

  return (
    <div className="space-y-4 w-full">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <TextInput
          source="first_name"
          validate={required()}
          helperText={false}
        />
        <TextInput
          source="last_name"
          validate={required()}
          helperText={false}
        />
      </div>
      <TextInput
        source="email"
        type="email"
        validate={[required(), email()]}
        helperText={false}
      />
      <BooleanInput
        source="administrator"
        readOnly={isSelf}
        helperText={false}
      />
      <BooleanInput source="disabled" readOnly={isSelf} helperText={false} />
      {isSelf ? (
        <p className="text-xs text-muted-foreground">
          {translate("resources.sales.hint.self_protection")}
        </p>
      ) : null}
    </div>
  );
}
